import { TYPE } from '../actions/types'

export default function (state = {}, action) {
    switch (action.type) {
        case TYPE.GET_REVIEW:
            return { ...state, response: action.payload }
        case TYPE.POST_REVIEW:
            return { ...state, response: action.payload }
        default:
            return state;
    }
}

